/**
 * Sends logged-out visitors on a project-scoped path back to the public twin —
 * `getProjectPath` cannot express the anonymous case, see `useDesignRoot`.
 */
export default defineNuxtRouteMiddleware((to) => {
  const auth = useAuth()
  const projectId = Array.isArray(to.params.projectId) ? to.params.projectId[0] : to.params.projectId

  if (!auth.isLoggedIn && projectId) {
    const publicPath = to.path.replace(/^\/project\/[^/]+/, '') || '/design-tokenomics'
    return navigateTo({ path: publicPath, query: to.query, hash: to.hash })
  }
})
